import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';
import { AuthProvider } from './lib/auth';
import { queryClient } from './lib/queryClient';
import { PortalApp } from './portal/PortalApp';

const basePath = (import.meta.env.VITE_BASE_PATH ?? '/conexao-varga/').replace(/\/$/, '');

/**
 * `apps/web` serve dois públicos sob `/conexao-varga/` (UX-PORTAL-CLIENTE §0):
 * - `/painel/*` → painel interno (basename `<base>/painel`, densidade própria);
 * - todo o resto → portal do cliente + landing do convite (basename `<base>`,
 *   sistema visual do DESIGN-FOUNDATION inteiro).
 * Shells separados; compartilham cliente HTTP, contexto de auth e tokens de cor.
 */
const ehPainel = window.location.pathname.startsWith(`${basePath}/painel`);
const basename = ehPainel ? `${basePath}/painel` : basePath;

const raiz = document.getElementById('root');
if (!raiz) throw new Error('#root não encontrado');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={basename}>
        <AuthProvider>{ehPainel ? <App /> : <PortalApp />}</AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
